import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/version")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Version {APP_VERSION}</div>;
}
